import * as React from "react";
import styled from "styled-components";
import { EuiListGroup, EuiListGroupItem } from "@elastic/eui";
import Tags from "./tags";

const StyledEuiListGroup = styled(EuiListGroup)`
    padding: 0 !important;
    width: 30%;
`;

const StyledEuiListGroupItem = styled(EuiListGroupItem)`
    width: 100%;
    margin-top: 0 !important;

    &.group-item {
        background-color: ${(props) => (props.isActive ? "#F3FAFF" : "#ffff")} !important;
        border: 1px solid #c8d4e945;
        border-radius: 4px;
        padding: 8px 16px;
    }

    *,
    *:hover {
        text-decoration: none !important ;
    }

    .euiListGroupItem__label {
        width: 100%;
    }
`;

const ListItem = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    justify-content: space-between;
    align-items: center;
    color: #006bb4;
    text-transform: capitalize;
    flex-wrap: wrap;
`;

export default function TabList({ list, handleOnClick }) {
    const [activeId, setActiveId] = React.useState(0);

    return (
        <StyledEuiListGroup>
            {list?.map((item, index) => (
                <StyledEuiListGroupItem
                    onClick={() => {
                        handleOnClick(item);
                        setActiveId(index);
                    }}
                    label={
                        <ListItem>
                            {item.text}
                            <Tags label={item?.label} />
                        </ListItem>
                    }
                    isActive={index === activeId}
                    className="group-item"
                />
            ))}
        </StyledEuiListGroup>
    );
}
